var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPlayButtonStrmClass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -14,
    y: -14,
    width: 60,
    height: 60
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(7px)",
      clipPath: "url(#bgblur_0_22078_15489_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 14
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "#CECDFF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#CECDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.651 14.5998L15.1434 12.0146C14.8995 11.8738 14.6226 11.8 14.341 11.8008C14.0593 11.8016 13.7829 11.8769 13.5398 12.019C13.2966 12.1612 13.0955 12.3652 12.9567 12.6103C12.8179 12.8554 12.7465 13.1329 12.7496 13.4145V18.6034C12.7496 19.0267 12.9177 19.4326 13.217 19.7319C13.5163 20.0311 13.9222 20.1993 14.3455 20.1993C14.6257 20.1988 14.9008 20.1248 15.1434 19.9846L19.651 17.3995C19.8932 17.2593 20.0943 17.0579 20.2341 16.8155C20.3739 16.5731 20.4475 16.2981 20.4475 16.0183C20.4475 15.7385 20.3739 15.4635 20.2341 15.2211C20.0943 14.9787 19.8932 14.7773 19.651 14.6371V14.5998ZM19.1844 16.5549L14.6768 19.1774C14.5757 19.2346 14.4616 19.2647 14.3455 19.2647C14.2293 19.2647 14.1152 19.2346 14.0142 19.1774C13.9134 19.1192 13.8298 19.0355 13.7716 18.9348C13.7135 18.834 13.6828 18.7197 13.6829 18.6034V13.3959C13.6828 13.2795 13.7135 13.1652 13.7716 13.0645C13.8298 12.9637 13.9134 12.8801 14.0142 12.8219C14.1156 12.7655 14.2294 12.7351 14.3455 12.7332C14.4614 12.7356 14.5751 12.766 14.6768 12.8219L19.1844 15.4257C19.2852 15.4838 19.3689 15.5675 19.4271 15.6682C19.4853 15.769 19.5159 15.8833 19.5159 15.9996C19.5159 16.116 19.4853 16.2303 19.4271 16.331C19.3689 16.4318 19.2852 16.5154 19.1844 16.5736V16.5549Z",
    fill: "#F2F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_22078_15489_clip_path",
    transform: "translate(14 14)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlayButtonStrmClass);
export default __webpack_public_path__ + "static/media/icon-play-button-strm-class.827669e823e40648a3b7f7705852299a.svg";
export { ForwardRef as ReactComponent };